export default {
  state: {
    fullPageLoading: false,
    localLoading: {
      active: false,
      componentId: null
    }
  },
  mutations: {
    setFullPageLoading (state, payload) {
      state.fullPageLoading = payload
    },
    setLocalLoading (state, payload) {
      state.localLoading = payload
    }
  },
  getters: {
    isFullPageLoading (state) {
      return state.fullPageLoading
    },
    isLocalLoading (state) {
      return state.localLoading
    }
  }
}
